var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5713 7.07988C20.1137 13.3403 15.6676 14.4 9.69517 14.4L7.89455 24H11.1913C11.7919 24 12.0434 23.591 12.1542 23.015C12.9762 17.8178 12.8607 18.6683 12.9353 17.8547C13.0063 17.4011 13.3987 16.8 13.8597 16.8C18.2385 16.8 21.1428 15.5342 22.0299 10.9898C22.3453 9.37344 22.2418 8.12628 21.5713 7.07988ZM7.96195 14.2318L6.6151 21.6H2.44333C2.04854 21.6 1.74643 21.1175 1.80902 20.7287L4.92399 0.901172C5.00584 0.382772 5.4548 0 5.98199 0H13.4625C17.8918 0 20.8744 1.68144 20.1847 6.06504C18.9775 13.8722 12.2854 13.2 9.24019 13.2C8.713 13.2 8.045 13.7134 7.96195 14.2318Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalicon);
export default __webpack_public_path__ + "static/media/paypalicon.11e7136d636868fdb0be85f6739b35e3.svg";
export { ForwardRef as ReactComponent };